/* ======================================
              CONFIG NGRX
====================================== */

import { ActionReducerMap } from '@ngrx/store';
import {
  StoreStateConfig, StoreStateAlert, StoreStateUser, StoreStateDataProvider, StoreStateSearcherBooks, StoreStateSearcherAuthors
} from '@shared/redux/store-state.model';
import {
  reducerConfig, reducerAlert, reducerUser, reducerDataProvider, reducerSearcherBooks, reducerSearcherAuthors
} from '@shared/redux/reducers/reducers-store-state.model';


export interface AppState {
  storeConfig: StoreStateConfig;
  storeAlert: StoreStateAlert;
  storeUser: StoreStateUser;
  storeDataProvider: StoreStateDataProvider;
  storeSearcherBooks: StoreStateSearcherBooks;
  storeSearcherAuthors: StoreStateSearcherAuthors;
}

export const reducers: ActionReducerMap<AppState> = {
  storeConfig: reducerConfig,
  storeAlert: reducerAlert,
  storeUser: reducerUser,
  storeDataProvider: reducerDataProvider,
  storeSearcherBooks: reducerSearcherBooks,
  storeSearcherAuthors: reducerSearcherAuthors,
};
